import * as requestFromServer from "./AdvisorsCrud";
import { callTypes, advisorSlice } from "./AdvisorsSlice";

const {actions} = advisorSlice;

export const getAdvisors = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getAdvisors(queryParams)
    .then(response => {
      dispatch(actions.advisorsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllAdvisors = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllAdvisors(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getTeachers = term => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getTeachers(term)
    .then(response => {
      dispatch(actions.teachersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getTeachersWithBranches = term => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getTeachersWithBranches(term)
    .then(response => {
      dispatch(actions.teachersWithBranchesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudents = queryParams => async dispatch => {
  if (queryParams.term) {
    dispatch(actions.startCall({ callType: callTypes.list }));
    return requestFromServer
      .getStudents(queryParams)
      .then(response => {
        dispatch(actions.studentsFetched(response.data));
      })
      .catch(error => {
          
      });
  };
}  

export const getRegistrationInfoIds = (teacherId, term) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getRegistrationInfoIds(teacherId, term)
    .then(response => {
      dispatch(actions.registrationInfoIdsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveAdvisorStudents = (teacherId, term, ids) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveAdvisorStudents(teacherId, term, ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteAdvisors = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteAdvisors(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanRegistrationInfoIds = () => dispatch => {
  dispatch(actions.registrationInfoIdsCleaned());
};

export const cleanAdvisorsState = () => dispatch => {
  dispatch(actions.advisorsStateCleaned());
};